export const EXISTENCE_CHECK_PAGINATION = { limit: 1, offset: 0 } as const
